<script setup lang="ts">
import { useAllStores } from '@/store'
import { useMyFetch } from '@/utils'
import { handleError } from '@/utils/errors'

const { organizationStore, alertStore, authStore, router, t, route } = useAllStores()
const { data, error } = await useMyFetch(`servers/detail/${route.params.server_id}/users`).json()
await handleError(error, router, authStore, alertStore)

async function edit(id: string) {
  await router.push({
    name: 'organizations:members:edit',
    params: { organization_id: organizationStore.organization.id, member_id: id }
  })
}
</script>

<i18n lang="yaml">
en:
  users: Users
  empty: 'No users found. Assign tags to users for them to show up here.'
  assign_tags: Assign tags
ru:
  users: Пользователи
  empty: 'Пользователи не найдены. Назначьте теги пользователям, чтобы они появились здесь.'
  assign_tags: Назначить теги
</i18n>

<template>
  <div class="card">
    <h4 class="card-header">
      {{ t('users') }}
      <router-link
        v-if="data && data.length"
        :to="{
          name: 'organizations:members',
          params: { organization_id: organizationStore.organization.id }
        }"
      >
        <img src="@/assets/pencil.svg" class="float-end" />
      </router-link>
    </h4>
    <div class="card-body">
      <div
        @click="edit(person.id)"
        class="mb-4 person p-2"
        v-if="data && data.length"
        v-for="person in data"
      >
        <img src="@/assets/person.svg" />
        <span class="ms-2"
          ><kbd>{{ person.username }}</kbd></span
        >
        <span class="ms-2">{{ person.email }}</span>
        <span key="tag" v-for="tag in person.tags" class="badge bg-primary ms-2">{{ tag }}</span>
      </div>
      <div v-else>
        <p>{{ t('empty') }}</p>
        <router-link
          :to="{
            name: 'organizations:members',
            params: { organization_id: organizationStore.organization.id }
          }"
          class="btn btn-outline-primary"
          >{{ t('assign_tags') }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<style>
.person {
  display: flex;
  align-items: center;
}
.person:hover {
  background-color: #f0f0f0;
}
</style>
